import { useLocation } from "react-router-dom";

export interface IQueryParamsValues {
  [key: string]: string;
}

export function useGetParamsObjectFromQuery() {
  const queryParams = new URLSearchParams(useLocation().search) 
  const queryParamsToObject: IQueryParamsValues = {}


  for(let [key, value] of queryParams.entries()) {
    queryParamsToObject[key] = value
  }

  return queryParamsToObject
}
